import { render, staticRenderFns } from "./JiNanTwoTicket.vue?vue&type=template&id=40ae9128&scoped=true"
import script from "./JiNanTwoTicket.vue?vue&type=script&lang=js"
export * from "./JiNanTwoTicket.vue?vue&type=script&lang=js"
import style0 from "./JiNanTwoTicket.vue?vue&type=style&index=0&id=40ae9128&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ae9128",
  null
  
)

export default component.exports